import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "../../../components/AuthProvider";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { PageSkeleton } from "../../../components/RouteSkeleton";
import { NotebooksPage } from "@/components/admin/notebooks";
import type { RouterContextWithSession } from "../../../router";

export const Route = createFileRoute("/_admin/notebooks/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  loader: async ({ context }) => {
    if (typeof window === "undefined") return;
    const { session } = context as RouterContextWithSession;
    if (!session) return;
    await context.queryClient.ensureQueryData({
      queryKey: ["route", "notebooks"],
      queryFn: async () => null,
      staleTime: Infinity,
    });
  },
  pendingComponent: () => <PageSkeleton rows={4} variant="cards" />,
  errorComponent: createRouteError("Notebooks"),
  component: NotebooksRoutePage,
});

function NotebooksRoutePage() {
  const { loading, isAuthenticated } = useAuth();

  if (loading || !isAuthenticated) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  return <NotebooksPage />;
}
